import React from 'react';
import * as R from 'ramda';
import { bool, string } from 'prop-types';
import { Box, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const Text = styled(Typography)({
  cursor: 'default',
  fontSize: 12,
  fontWeight: 600,
  marginTop: 3,
});

const ProductIndicatorBadge = props => {
  const { className, proprietary } = props;

  const type = R.ifElse(
    R.equals(true),
    R.always({
      backgroundColor: 'primary.light',
      color: 'primary.dark',
      tag: 'PP',
      title: 'Proprietary Product',
    }),
    R.always({
      backgroundColor: 'graphic.light',
      color: 'text.secondary',
      tag: 'GP',
      title: 'Generic Product',
    })
  )(proprietary);

  const { backgroundColor, color, title, tag } = type;
  return (
    <Box
      alignItems="center"
      borderRadius="4px"
      className={className}
      display="flex"
      height={20}
      justifyContent="center"
      p={0.5}
      sx={{
        backgroundColor,
        color,
      }}
      width={32}
    >
      <Tooltip arrow enterTouchDelay={10} placement="bottom" title={title}>
        <Text color="inherit" variant="body1">
          {tag}
        </Text>
      </Tooltip>
    </Box>
  );
};

ProductIndicatorBadge.propTypes = {
  className: string,
  proprietary: bool,
};

ProductIndicatorBadge.defaultProps = {
  className: undefined,
  proprietary: null,
};

export default ProductIndicatorBadge;
